export default {"src":"/_next/static/media/menu_icon.8353cc49.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};